import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { AppConfigService } from './../../services/app-config-service/app-config.service';

@Component({
  selector: 'app-language-attribute',
  encapsulation: ViewEncapsulation.None,
  template: '@if ((lang$ | async)) {<div></div>}',
  imports: [CommonModule],
})
export class LanguageAttributeComponent implements OnInit {
  // https://github.com/ngx-translate/core/issues/565
  lang$: Observable<string> = undefined;

  constructor(
    private readonly translateService: TranslateService,
    private readonly appConfigService: AppConfigService,
    @Inject(DOCUMENT) private readonly document: Document
  ) {}

  ngOnInit() {
    this.lang$ = this.translateService.onLangChange.pipe(
      map((langChangeEvent: LangChangeEvent) => langChangeEvent.lang),
      tap((lang: string) => this.updateLanguage(lang)),
      tap((lang: string) => this.updateTextDirection(lang))
    );
  }

  updateLanguage(language: string): void {
    const lang = this.document.createAttribute('lang');
    lang.value = language;
    this.document.querySelector('html').attributes.setNamedItem(lang);
  }

  updateTextDirection(language: string): void {
    const possibleTranslationFiles = this.appConfigService.cepTranslation.filter(translation => translation.localeKey === language);
    const dir = possibleTranslationFiles.length === 1 ? possibleTranslationFiles[0].translationTable.dir : 'rtl';

    const lang = this.document.createAttribute('dir');
    lang.value = dir;
    this.document.querySelector('html').attributes.setNamedItem(lang);
  }
}
